module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r7n9r3r-096fe417bdc922f68bae8790a97c0b36.svg";